import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Constants } from '../../app.constants';
import { roleBasedGuard } from './role-based.guard';

// The generic extracts route can preselect an extract type by query param; WA OSPI keeps its own role list.
export const waOspiTypeGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  if (route.queryParamMap.get('extractType') !== 'wa-ospi-lap') {
    return true;
  }

  const waOspiRoute = { data: { allowedRoles: Constants.WA_OSPI_EXTRACT_ALLOWED_ROLES } } as unknown as ActivatedRouteSnapshot;
  return roleBasedGuard(waOspiRoute, state);
};
